window.addEventListener("load", () => {
  let elementsToHide = document.querySelectorAll(
    '[id*="shopify-section-sections-"]'
  );

  let form = document.body.querySelector("#contact_form");
  let mainBody = document.body.querySelector("#MainContent");

  if (window.location.href.includes("challenge")) {
    mainBody.classList.remove("hidden");
    let maintenanceContainer = document.getElementById(
      "under_maintenance_container"
    );
    elementsToHide.forEach((element) => {
      element.style.display = "none";
      maintenanceContainer.style.display = "none";
    });
    iframe.classList.remove("hidden");
  } else if (window.location.href.includes("contact_posted=true")) {
    let maintenanceBodyMsg = document.getElementById("maintenance-body-msg");
    let thankYouBox = document.querySelector("#maintenance_thank_you");
    thankYouBox.classList.remove("hidden");
    maintenanceBodyMsg.classList.add("hidden");
    form.classList.add("hidden");
  }
});
